import { useDetectTruncation } from '#hooks/PRIVATE_useDetectTruncation';
import { useTooltip } from '#hooks/UNSAFE_useTooltip';
import { mergeProps } from '#utils/UNSAFE_mergeProps';

const useTooltipOnTruncation = (tooltipText?: string, isDisabled = false) => {
  const { detectTruncationProps, isTextTruncated } = useDetectTruncation(isDisabled);
  const { tooltipContent, tooltipProps } = useTooltip({
    text: tooltipText,
    isDisabled: !isTextTruncated || isDisabled
  });

  const { 'aria-describedby': notNeeded, ...validTooltipProps } = tooltipProps; //remove aria-describedby to prevent screen readers from reading the same text multiple times

  const tooltipOnTruncationProps = mergeProps(detectTruncationProps, validTooltipProps);

  return { tooltipOnTruncationProps, tooltipContent, isTextTruncated };
};

export { useTooltipOnTruncation };
